import { createGlobalStyle } from 'styled-components';
import { color } from 'styles/pallete';

const GlobalStyle = createGlobalStyle`
     *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
     }

    /* Scrollbar */
    ::-webkit-scrollbar {
        max-width: 4px; /* width of the entire scrollbar */
        height: 4px;
    }

    ::-webkit-scrollbar-track {
        background: ${color.interface.white}; /* color of the tracking area */
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${color.interface.lightGray5}; /* color of the scroll thumb */
        border-radius: 20px; /* roundness of the scroll thumb */
        border: 1px solid ${color.interface.lightGray5}; /* creates padding around scroll thumb */
    }

    html{
        font-size: 62.5%;
    }

    html, body{
        height: 100%;
    }

    body{
         font-family: nunito-regular, 'Open Sans', 'Helvetica Neue', sans-serif;
         font-size: 1.2rem;
    }

    .noPadding{
        padding: 0 !important;
    }
`;

export default GlobalStyle;
